"use strict";

(function (global) {
  var reportPage = {};

  /**
  * Базовый диалог отчетов для вывода ошибок и информационных сообщений.
  */
  reportPage.ReportDialog = WA.CMP.dialogs.MessageBox.extend({
    init: function () {
      this.ok = WA.CR.window.close;
      this.setWidth(500);
      this.modal = false;
    }
  });

  /**
     * Отображение модального окна с текстом ошибки.
     * При закрытии окна страница перезагружается.
     * @param {string} Текст ошибки. 
     */
  reportPage.showError = function (text) {
    (new reportPage.ReportDialog).show(text, null, L('ERR'), 'error');
  };

  /**
   * Отображение диалога завершения генерации отчета.
   */
  reportPage.showFinishDialog = function () {
    (new reportPage.ReportDialog).show(L('COMPLETING_WORKING_WITH_REPORT_MESSAGE'),
      null,
      L('COMPLETING_WORKING_WITH_REPORT'),
      "info");
  };

  /**
   * Отображение в шапке спиннера.
   */
  reportPage.showSpinner = function () {
    reportPage.jCaptionContainer.hide();
    reportPage.jSpinner.show();
  };

  /**
   * Скрытие спиннера.
   */
  reportPage.hideSpinner = function () {
    reportPage.jCaptionContainer.show();
    reportPage.jSpinner.hide();
  };

  global.reportPage = reportPage;
}(window.Core));

/**
  * Инициализация отчета.
  */
WebAccess.ready(function () {
  if (WA.getLocation() === 'report') {
    Core.reportPage.jCaption = $("#ReportName");
    Core.reportPage.jCaptionContainer = $("#captionContainer");
    Core.reportPage.jSpinner = $("#spinner");
    Core.reportPage.jSpinnerText = $("#spinnerText");

    var url = new WebAccess.URL;
    var reportName = url.getParam('compcode') || url.getParam('name');

    // Это плохой способ декодировать имя из урла, но другого не нашлось, если  найдется клиентский - заменить в url.getParam.
    WA.services.call("report.asmx/DecodeReportName", { ReportName: reportName }).done(function(reportName) {
      var report = WA.factories.reports(reportName);

      WA.services.call("report.asmx/getreportcaption", {
        ReportName: reportName,
        SerializedForm: null
      }).done(function (reportCaption) {
        Core.reportPage.jCaption.html(format(L('REPORT'), reportCaption));
        Core.reportPage.jSpinnerText.html(format(L('GENERATING_REPORT'), reportCaption));

        // Перед непосредственным выполнением отчета нужно начинать крутить спиннер.
        report.bind(report['class'].EVENT.BEFORE_EXECUTING, function () {
          Core.reportPage.showSpinner();
        });

        // Перед непосредственным выполнением отчета нужно начинать крутить спиннер.
        report.bind(report['class'].EVENT.ABORT_FILLING_PARAMS, function () {
          WA.CR.window.close();
        });

        // Начать выполнение отчета.
        report.queryParamsAndExecute().always(function () {
          Core.reportPage.hideSpinner();
        }).done(function (report) {
          report.open();
          Core.reportPage.showFinishDialog();
        }).fail(function (ex) {
          Core.reportPage.showError(ex);
        });
      }).fail(function (ex) {
        Core.reportPage.showError(ex);
      });;
    });
  };
});